//
import { queryList, saveObject, updateObject, getAllRoleList, getAllRdcList, getAllCarrierList, getResetRoleList, getResetPwd, getDeleteUserList, getForceResetPwd, initRolePrivilegeData, userUpLoad } from './../api';
import {userType, getUserCategory, selectRole,selectCarrier} from '../../../../api'
import { Message } from 'element-ui';
const user = {
  namespaced: true,
  state: {
    successCode: 200,
    resp: null,
    userAdd: null,
    updateData: null,
    allRoleList: null,
    allRdcList: null,
    allCarrierList: null,
    resetRoleList: null,
    resetPwdList: null,
    forceResetPwdList: null,
    deleteUserList: null,
    total: null,
    userTypeObj: null,
    initRolePrivilegeDataObj: null,
    userCategoryObj: null,
    selectRoleInfoObj: null,
    userResp: null,
    carrierObj: null,
  },
  mutations: {
    queryList(state, resp) {
      if (resp.code === state.successCode) {
        Message({ showClose: true, message: resp.msg, type: 'success' });
      }
      state.total = resp.total
      state.resp = (resp.obj || []).map((item, index) => {
        return {
          ...item,
          useStatusDesc: item.useStatus == '10' ? '正常' : (item.useStatus == '20' ? '离职' : '待激活'),
          btns: [true, true, true, true, true, item.isQiyeWxLoginStr == '已绑定'],//每行数据的操作按钮权限
        }
      });
    },
    SAVE_OBJECT(state, resp) {
      state.userAdd = resp
    },
    UP_DATE_OBJECT(state, resp) {
      state.updateData = resp
    },
    GET_ALL_ROLE_LIST(state, resp) {
      state.allRoleList = resp
    },
    GET_ALL_RDC_LIST(state, resp) {
      state.allRdcList = resp
    },
    GET_ALL_CARRIER_LIST(state, resp) {
      state.allCarrierList = resp
    },
    LIST_USER_CATEGORY_DATA(state, resp) {
      state.userCategoryObj = resp;
    },
    GET_RESET_ROLE_LIST(state, data) {
      state.resetRoleList = data
    },
    GET_RESET_PWD(state, data) {
      state.resetPwdList = data
    },
    GET_FORCE_RESET_PWD(state, data) {
      state.forceResetPwdList = data
    },
    GET_DELETE_USER(state, data) {
      state.deleteUserList = data
    },
    setData(state, data) {
      state[data.page] = data;
    },
    GET_ALL_USER_TYPE_LIST(state, data) {
      state.userTypeObj = data
    },
    INIT_ROLE_PRIVILEGE_DATA(state, data) {
      state.initRolePrivilegeDataObj = data || {};
    },
    SELECT_ROLEINFO_DATA(state, resp){
      state.selectRoleInfoObj = resp.obj || [];
    },
    SELECT_CARRIER(state, resp){
      state.carrierObj = resp.obj || [];
    },

    UPLOAD_DATA(state, data) {
      state.userResp = data;
    },
    DOWN_LOAD_TEMPLATE(state, data) {
      state.templateObj = data;
    }
  },
  actions: {
    async setData({ commit }, data) {
      commit('setData', data);
    },
    async queryList({ commit }, obj) {
      let resp = await queryList(obj);
      commit('queryList', resp);
    },
    async getAddUser({ commit }, obj) {
      let resp = await saveObject(obj);
      commit('SAVE_OBJECT', resp);
    },
    async updateObject({ commit }, obj) {
      let resp = await updateObject(obj);
      commit('UP_DATE_OBJECT', resp);
    },
    async getAllRoleList({ commit }, obj) {
      let resp = await getAllRoleList(obj);
      commit('GET_ALL_ROLE_LIST', resp);
    },
    async getResetRoleList({ commit }, obj) {
      let resp = await getResetRoleList(obj);
      commit('GET_RESET_ROLE_LIST', resp);
    },
    async getResetPwd({ commit }, obj) {
      let resp = await getResetPwd(obj);
      commit('GET_RESET_PWD', resp);
    },
    async getForceResetPwd({ commit }, obj) {
      let resp = await getForceResetPwd(obj);
      commit('GET_FORCE_RESET_PWD', resp);
    },
    async getDeleteUserList({ commit }, obj) {
      let resp = await getDeleteUserList(obj);
      commit('GET_DELETE_USER', resp);
    },
    //查询rdc
    async getAllRdcList({ commit }, obj) {
      let resp = await getAllRdcList(obj);
      commit('GET_ALL_RDC_LIST', resp);
    },
    //查询carrier
    async getAllCarrierList({ commit }, obj) {
      let resp = await getAllCarrierList(obj);
      commit('GET_ALL_CARRIER_LIST', resp);
    },
    //查询carrier
    async listUserType({ commit }, obj) {
      let resp = await userType(obj);
      commit('GET_ALL_USER_TYPE_LIST', resp);
      console.log("---------", user.state.userTypeObj)
    },
    async listUserCategory({ commit }, obj) {
      let resp = await getUserCategory(obj);
      commit('LIST_USER_CATEGORY_DATA', resp);
    },
    async initRolePrivilegeData({ commit }, obj) {
      let resp = await initRolePrivilegeData(obj);
      commit('INIT_ROLE_PRIVILEGE_DATA', resp);
    },
    //角色
    async ListRoleInfoSelect({ commit }, obj) {
      let resp = await selectRole(obj);
      commit('SELECT_ROLEINFO_DATA', resp);
    },

    //物流商
    async ListCarrierSelect({ commit }, obj) {
      let resp = await selectCarrier(obj);
      commit('SELECT_CARRIER', resp);
    },
    //导入数据
    async userUpLoad({ commit }, obj) {
      let resp = await userUpLoad(obj);
      commit('UPLOAD_DATA', resp);
    },
    //下载模板
    async template({ commit }, obj) {
      let resp = await template(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/page/auth/user/store/user.store.js